import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import { isAuthenticated, isAdmin } from '../auth.js'

// Non-login routes are lazy-loaded so their chunks (and their dependencies)
// are only fetched when first visited, keeping the initial bundle small.
const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/ReportsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/budget',
    name: 'budget',
    component: () => import('../views/BudgetView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/debts',
    name: 'debts',
    component: () => import('../views/DebtsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/accounts',
    name: 'accounts',
    component: () => import('../views/AccountsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/income',
    name: 'income',
    component: () => import('../views/IncomeView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    component: () => import('../views/WishlistView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const authenticated = isAuthenticated()

  if (to.meta.requiresAuth && !authenticated) {
    return { name: 'login' }
  }

  if (to.meta.requiresAdmin && !isAdmin()) {
    return { name: 'home' }
  }

  if (to.name === 'login' && authenticated) {
    return { name: 'home' }
  }

  return true
})

export default router
